import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { Renewal } from './sub-models/renewal.model';
import { RenewalPromotion } from './sub-models/renewal-promotion.model';
import { CreditCard } from './sub-models/credit-card.model';
import { RenewalSubscription } from './sub-models/renewal-subscription.model';

export const RENEWAL_INFO_SCHEMA = Object.freeze({
  SAVED_CARD: CreditCard, // nullable
  ENCRYPTED_ACCOUNT_ID: '',
  BRAINTREE_WILL_AUTORENEW: false,
  IS_IOS_RECURRING: false,
  PURCHASE_DATE: '',
  RENEWAL: Renewal, // nullable
  PROMOTION: RenewalPromotion, // nullable
  SUBSCRIPTION: RenewalSubscription,
});
const RECORD = generateSchema(RENEWAL_INFO_SCHEMA);
const KEYS: any = generateKeys(RENEWAL_INFO_SCHEMA);

export class RenewalInfo extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.SAVED_CARD,
        value: props.get(KEYS.SAVED_CARD)
          ? new CreditCard(this.savedCard)
          : null,
      },
      {
        key: KEYS.RENEWAL,
        value: props.get(KEYS.RENEWAL) ? new Renewal(this.renewal) : null,
      },
      {
        key: KEYS.PROMOTION,
        value: props.get(KEYS.PROMOTION)
          ? new RenewalPromotion(this.promotion)
          : null,
      },
      {
        key: KEYS.SUBSCRIPTION,
        value: new RenewalSubscription(this.subscription),
      },
    ]);

    return selfModel as RenewalInfo;
  }

  get savedCard(): CreditCard | null {
    return this.get(KEYS.SAVED_CARD);
  }

  get encryptedAccountId(): string {
    return this.get(KEYS.ENCRYPTED_ACCOUNT_ID);
  }

  get braintreeWillAutorenew(): boolean {
    return this.get(KEYS.BRAINTREE_WILL_AUTORENEW);
  }

  get isIosRecurring(): boolean {
    return this.get(KEYS.IS_IOS_RECURRING);
  }

  get purchaseDate(): string {
    return this.get(KEYS.PURCHASE_DATE);
  }

  get renewal(): Renewal | null {
    return this.get(KEYS.RENEWAL);
  }

  get promotion(): RenewalPromotion | null {
    return this.get(KEYS.PROMOTION);
  }

  get subscription(): RenewalSubscription {
    return this.get(KEYS.SUBSCRIPTION);
  }
}
